module.exports = __webpack_public_path__ + "img/WechatQR.f770e7ec.png";